module.exports = __webpack_public_path__ + "img/chevron-down.6162a60b.svg";